;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"paths-ui@20260608_0836_4e678ab"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.5.7";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = "https://__kausal_asset_prefix_placeholder__";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from '@sentry/nextjs';

import { initBrowserRootLogger } from '@common/logging/browser';
import { initSentryBrowser } from '@common/sentry/client-init';

initBrowserRootLogger();
initSentryBrowser();

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
